const getters = {
  token: (state) => state.user.token,
  avatar: (state) => state.user.avatar,
  userInfo: (state) => state.user.userInfo,
  roles: (state) => state.user.roles,
  administratorHead: (state) => state.user.administratorHead,
  administratorId: (state) => state.user.administratorId,
  administratorName: (state) => state.user.administratorName,
};
export default getters;
